import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { PersonOutline } from "@mui/icons-material";
import {
  Grid,
  DialogActions,
  DialogContent,
  FormControl,
  Slide,
  Snackbar,
  TextField,
  Alert,
  Dialog,
} from "@mui/material";
import {
  cardBodyStyle,
  ButtonExit,
  ButtonStyle0,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function NewAdvisorAdmin(props) {
  const classes = useStyles();
  const { urlServices, UserAuth } = useContext(UrlServicesContext);
  const keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({ name: "", errorName: false });
  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [errorAlert, setErrorAlert] = useState("error");
  const [openAlertSuccess, setOpenAlertSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value, errorName: false });
    setOpenAlert(false);
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setOpenAlert(false);
    setError(false);
    setOpenAlertSuccess(false);

    if (!values.name.trim()) {
      setValues({ ...values, errorName: true });
      setMensaje('El campo "Nombre" es obligatorio.');
      setErrorAlert("error");
      setOpenAlert(true);
      return;
    }

    try {
      const response = await axios.post(
        `${urlServices}advisor`,
        { name: values.name.toUpperCase().trim(), status: 1 },
        { headers: { Authorization: `Bearer ${keyAuthorization}` } },
      );

      if (response.status === 201) {
        setOpenAlertSuccess(true);
        setValues({ name: "", errorName: false });
        props.callBackRefresh();
      }
    } catch (e) {
      if (e.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
      } else {
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      }
    }
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        onClose={() => props.exit()}
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{ sx: { borderRadius: 6 } }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12}>
                {error && <Alert severity="error">{mensageSystem}</Alert>}
                <div className={classes.titleCardFilter}>Nuevo asesor</div>
                <div className={classes.lineBottom}></div>
              </Grid>
              <Grid item xs={12}>
                <FormControl style={{ width: "100%" }}>
                  <TextField
                    name="name"
                    value={values.name}
                    error={values.errorName}
                    onChange={handleChange("name")}
                    fullWidth
                    required
                    size="small"
                    label="Nombre completo"
                    margin="dense"
                    autoComplete="off"
                    variant="outlined"
                    inputProps={{ style: { textTransform: "uppercase" } }}
                    InputProps={{
                      endAdornment: (
                        <PersonOutline
                          fontSize="small"
                          className={classes.iconInput}
                        />
                      ),
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <center>
                  <ButtonStyle0 onClick={submitForm}>
                    Guardar asesor
                  </ButtonStyle0>
                </center>
              </Grid>
              <Grid item xs={12}>
                <center>
                  {openAlertSuccess && (
                    <Alert severity="success">
                      Asesor registrado exitosamente.
                    </Alert>
                  )}
                </center>
              </Grid>
            </Grid>
            <Snackbar
              open={openAlert}
              autoHideDuration={6000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              onClose={() => setOpenAlert(false)}
            >
              <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
                <Alert
                  onClose={() => setOpenAlert(false)}
                  severity={errorAlert}
                  elevation={6}
                  variant="filled"
                >
                  {mensaje}
                </Alert>
              </Slide>
            </Snackbar>
          </Fragment>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={() => props.exit()}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
